import { STATUS_TYPES } from '../AnnualUserAccessReview/views/Edit/_const';
import SafetyCheckIcon from '@mui/icons-material/SafetyCheck';
import GppMaybeIcon from '@mui/icons-material/GppMaybe';
import Skeleton from '@mui/material/Skeleton';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import ShieldIcon from '@mui/icons-material/Shield';

export const getStatusIcon = type => {
	switch (type) {
		case STATUS_TYPES.OVERDUE:
			return <GppMaybeIcon sx={{ color: 'red' }} />;
		case STATUS_TYPES.VALID:
			return <VerifiedUserIcon sx={{ color: 'green' }} />;
		case STATUS_TYPES.VALID_EXPIRING_SOON:
			return <SafetyCheckIcon sx={{ color: 'orange' }} />;
		default:
			return (
				<Skeleton>
					<ShieldIcon />
				</Skeleton>
			);
	}
};
export const getStatusLabel = data => {
	switch (data.status) {
		case STATUS_TYPES.OVERDUE:
			return 'Overdue.  Expired on ' + data.nextValidationDue + '.';
		case STATUS_TYPES.VALID:
			return 'Valid until ' + data.nextValidationDue + '.';
		case STATUS_TYPES.VALID_EXPIRING_SOON:
			return 'Valid. Expires in ' + data.daysUntilExpiration + ' days.';
		default:
			return null;
	}
};

export const getDefaultRenewalDate = () => {
	const month = new Date().getMonth();
	const year = new Date().getFullYear();
	const newDate = new Date(year + 1, month + 1, 0);
	return newDate;
};
